import React from 'react';
import {
  Divider,
  Accordion,
  Icon,
  Label,
  Header,
  Dimmer,
  Loader,
} from 'semantic-ui-react';

const zeroPadding = {
  padding: '0px'
};

const zeroMargin = {
  margin: '0px'
};

const contentStyle = {
  paddingTop: '0px',
  paddingBottom: '1em'
};

const zeroBottomMargin = {
  marginBottom: '0px'
};

const flexWrapMarginRight20PX = {
  display: 'flex',
  flexWrap: 'wrap',
  marginRight: '20px'
};

const onTopRight = {
  position: 'absolute',
  right: '5px',
};

const rotateToMinus90 = {
  transform: 'rotate(-90deg)',
  transition: 'transform 0.15s linear',
};

const rotateToZero = {
  transform: 'rotate(0deg)',
  transition: 'transform 0.15s linear',
};

interface CardLayoutProps {
  // ReactElement
  content?: React.ReactElement;
  titleContent?: React.ReactElement;

  // String
  titleText?: string;
  ribbonColor?: string;
  headerColor?: string;
  loadingText?: string;
  topRightText?: string;

  // Boolean
  hideTitleText?: boolean;
  hideTitleContent?: boolean;
  hideDivider?: boolean;
  hideContent?: boolean;
  hideHeaderIcon?: boolean;
  toggleable?: boolean;
  closeable?: boolean;
  active?: boolean;
  ribbon?: boolean;
  loading?: boolean;
  readOnly?: boolean;
  hideTopRightText?: boolean;
  enableMargin?: boolean;

  // Function
  onClose?: () => void;

  // We're still not sure whether we need these properties or not
  // allowClose?: boolean | (() => void);
  // hideCallback?: () => void;
  // showCallback?: () => void;
}
class CardLayout extends React.PureComponent<CardLayoutProps,any> {
  static defaultProps = {
    headerColor: "blue",
    loadingText: "Loading",
    toggleable: true,
    active: true,
    closeable: true,
    onClose: () => {},
    defaultBackground: true,
    topRightText: "",
    hideTopRightText: true,
    enableMargin: true,
  };
  constructor(props) {
    super(props);
    this.state = {
      active: props.active,
      closeable: props.closeable,
    };

    // used for temporary preventing the accordion from being toggled
    // when a user click any component on the titleContent
    this.temporarilyPreventToggling = false;
  }

  handleTitleClick = (e) => {
    if (this.temporarilyPreventToggling) {
      this.temporarilyPreventToggling = false;
      return;
    }
    if (this.props.toggleable) {
      this.setState((prev) => ({ active: !prev.active }));
    }
  };

  handleTitleContentClick = () => {
    this.temporarilyPreventToggling = true;
  };

  handleIconClick = () => {
    this.temporarilyPreventToggling = true;
    if (this.props.closeable) {
      this.props.onClose();
    }
  };

  render() {
    const {
      style,
      children,
      titleContent,
      ribbon,
      closeable,
      titleText,
      loading,
      ribbonColor,
      hideTitleText,
      hideTitleContent,
      hideContent,
      hideDivider,
      hideHeaderIcon,
      readOnly,
      headerColor,
      loadingText,
      defaultBackground,
      topRightText,
      hideTopRightText,
      enableMargin,
    } = this.props;

    const { active } = this.state;

    return (
      <Dimmer.Dimmable
        dimmed={loading}
        className={enableMargin ? "CardLayout" : ""}
      >
        <Accordion
          styled
          fluid
          className={`${headerColor} raised segment ${
            defaultBackground ? "defaultBackground" : null
          }`}
          style={{ ...zeroPadding, ...zeroMargin, ...style }}
        >
          <Accordion.Title active={active} onClick={this.handleTitleClick}>
            {!hideHeaderIcon && (
              <Icon
                size="large"
                style={{
                  ...onTopRight,
                  ...(active ? rotateToMinus90 : rotateToZero),
                }}
                color={closeable ? "red" : "black"}
                name={closeable ? "close" : "caret left"}
                onClick={this.handleIconClick}
              />
            )}

            {!hideTopRightText && (
              <Header style={{ ...onTopRight, marginRight: 5 }}>
                {topRightText}
              </Header>
            )}

            <div style={flexWrapMarginRight20PX}>
              {!hideTitleText &&
                (ribbon ? (
                  <Label ribbon color={ribbonColor}>
                    {titleText}
                  </Label>
                ) : (
                  <Header style={zeroBottomMargin}>{titleText}</Header>
                ))}

              <div style={{ flexGrow: "1" }} />

              {!hideTitleContent && (
                <div onClick={this.handleTitleContentClick}>{titleContent}</div>
              )}
            </div>

            <Divider hidden={!active || hideDivider} />
          </Accordion.Title>

          <Accordion.Content active={active} style={contentStyle}>
            {!hideContent && children}
          </Accordion.Content>
        </Accordion>

        <Dimmer active={readOnly} inverted />
        <Dimmer active={loading} inverted>
          <Loader inverted>{loadingText}</Loader>
        </Dimmer>
      </Dimmer.Dimmable>
    );
  }
}

export default CardLayout;
